<template>
   <main id="lotto_winner_list">
    <div class="myPost_wrapper" id="more_board">
      <!-- title -->
      <div class="main_top">
        <h1>
          지난회차 결과
        </h1>
        <img src ="images/basic/icon/close-b.svg" onclick="history.back()" class="back">
      </div>
      <div class="div_padding"></div>
    </div>
     <div class="list_box">

     </div>
     <!-- 지난회차 당첨자 -->
     <div class="round-result prev-winners">
       <ul class="list">
         <!-- 지난회차 박스 반복 시작 -->
         <li v-for="(lotto, index) in lottoList" :key="index">
           <div class="winner_box_wrapper">
             <!-- 박스 상단 -->
             <div class="top_box">
              <div class="lt_box">
                <p>{{lotto.winNo}}회차</p>
                <p>{{lotto.winDate}}</p>
              </div>
              <div class="rt_box">
                <p>{{lotto.winnerAmount}} <span>TRX</span></p>
                <!-- <p>{{lotto.winUserListCnt > 0 ? lotto.winUserListCnt +"명/"+numberFormat(Number(lotto.winnerAmount/lotto.winUserListCnt)) + " TRX" : "당첨자가 없어 이월됩니다."}}</p> -->
                <p>{{lotto.winUserListCnt > 0 ? lotto.winUserListCnt +"명/"+numberFormat(Number(lotto.winnerAmount/lotto.winUserListCnt)) + " TRX" : ((lotto.winNo == 10)?"당첨자가 없이 시즌2 종료합니다":"당첨자가 없어 이월됩니다.")}}</p>
              </div>
             </div>
             <!-- //박스상단 -->
             <!-- 숫자 -->
             <div class="number_box">
               <div class="selected_ball_list">
                 <div class="num_ball" :style="`background:${getRandomColor(number)}`" v-for="(number,index) in lotto.winNumbers.split(',')" :key="index"> {{number}} </div>
               </div>
             </div>
             <!-- //숫자 -->
             <ul class="winners">
               <li>
                 <p v-show="lotto.winUserList.length == 0">당첨자가 없습니다.</p>
                 <!-- 당첨자 반복 시작 -->
                 <div class="user" v-for="(user, index) in lotto.winUserList" :key="index">
                   <div class="profile" style="background-image: url(&quot;undefined&quot;), url(&quot;/images/basic/img/default.svg&quot;); border-radius: 50%;"></div>
                   <div class="infos">
                     <span class="id">{{user.name}}</span>
                   </div>
                 </div>
               </li>
             </ul>

            <!-- BOTTOM 버튼 -->
            <div class="btm_box">
              <div class="half_box">
                <div class="btn_half" @click="goToAttendanceList(lotto.winNo)">
                  <p>{{lotto.winNo}}회차 참여자 보기</p>
                </div>
                <div class="btn_half" @click="goToMyPrevJoinList(lotto.winNo)">
                  <p>{{lotto.winNo}}회차 내 참여 보기</p>
                </div>
              </div>
            </div>

           </div>
         </li>
         <!-- //지난회차 박스 반복 종료 -->
         
       </ul>
     </div>

   
  </main>
</template>


<script>
import { fetchInfomation, fetchAdCheck, requestCreate, fetchTicket, requestUse, fetchJoinList, fetchWinnerInfo } from '@/api/ngame'
export default {
  created() {
    
  },
  mounted() {
    window.addEventListener("scroll",this.scrollCheck);
    this.fetchData();
  },
  destroyed() {
     window.removeEventListener('scroll', this.scrollCheck);
  },
  data() {
    return {
      randColorList: ['#FBC400', '#6AC7F1', '#FF7170', '#A7A2E0', '#6DCE9D'],
      pageIndex: 0,
      listCnt: 0,
      winnerList: [],
      lottoList: [],
    }
  },
  methods: {
    scrollCheck(){
      const offset = 50;
      var pageHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight,  document.documentElement.clientHeight,  document.documentElement.scrollHeight,  document.documentElement.offsetHeight );
      if ((window.innerHeight + window.scrollY) >= pageHeight - offset) {
        if(this.firstLoad){
          this.fetchData();
        }
      }
    },
    fetchData() {
      this.pageIndex += 1;
      fetchWinnerInfo({ 
        pageIndex:this.pageIndex
      }).then((data) =>{
        this.lottoList = [...this.lottoList, ...data.data.infoList];
      })
    },
    getRandomColor(number) {
      const color = this.randColorList[parseInt((number-1)/10)]
      return color;
    },
    numberFormat(num) {
      var exp = /\B(?=(\d{3})+(?!\d))/g;
      var num_str = Number(num).toFixed(3);
      return num_str.replace(exp, ',');
    },
    goToAttendanceList(winNo) {
      this.$router.push({
        path: '/lottoAttandanceList', query: {
          eventId: winNo,
          eventTitle: winNo+"회차 참여자",
          prev:"Y"
        }
      })
    },
    goToMyPrevJoinList(winNo) {
      this.$router.push({
        path: '/lottoMyPrevJoinList', query: {
          eventId: winNo,
          eventTitle: winNo+"회차 내 참여"
        }
      })
    },
  },
}
</script>

<style scoped>



</style>
